module.exports = "/_next/static/images/7720a11a61d5caf23b7f7ca6665ec9ab-roxinho-card-with-phone-lg@1x.jpg";